import React from 'react';
import { Tabs } from 'antd';

import { IMetalGroup } from '../../../../sharedInterfaces';
import { RadioGroup, TabSelect, isMobile, PurityDropdown, isLowHeight } from "../../ui-helpers";
import { ITabSelectTab } from '../../ui-helpers/TabSelect/TabSelect';

import {
  Image,
  OptionItem,
  RadioGroupWrapper,
  OptionsContainer,
  SectionTitle,
  MenuSection as MenuSection
} from './Materials-styled';
import { theme } from '../../../../styles';


const { TabPane } = Tabs;

interface IOptionProps {
  option:string,
  imgName:string,
  assetURI:string,
  isSelected:boolean,
  onClick:(value:any)=>void,
  children?:React.ReactNode
}

const Option:React.FunctionComponent<IOptionProps> = (props) => {
  const { option, imgName, assetURI, isSelected, onClick } = props;

  return (
    <OptionItem className="threed-configurator-menu-option-item"
      onClick={(e:React.MouseEvent) => {
        props.onClick(option);
        e.stopPropagation();
      }}
    >
      <Image
        width={!(isMobile() || isLowHeight()) ? 52 : 46}
        height={!(isMobile() || isLowHeight()) ? 52 : 46}
        borderWidth={3}
        showBorder={isSelected}
        src={`${assetURI}/images/materials/${imgName}.png`}
      />
      <div>
        {option}
      </div>
      {props.children}
    </OptionItem>
  )
};


interface Props {
  metalGroups:IMetalGroup[],
  onMetalGroupChange:(value:IMetalGroup)=>void,
  limitedMaterials:string[],
  currentMenuMetalGroup:IMetalGroup,
  onCurrentMenuMetalGroupChange:(setTo:string)=>void,
  assetURI:string
}

interface State {

}


export default class extends React.Component<Props,State> {
  constructor(props: Props) {
    super(props);
  };// /constructor()

  onParameterChange = (group:string, param:'material'|'surface'|'purity', value:any) => {
    //console.log('onParameterChange()', group, param, value);

    const { metalGroups } = this.props;
    const editedMetalGroup = metalGroups.find(({ name }) => name === group);

    this.props.onMetalGroupChange({
      ...editedMetalGroup,
      [param]: value,
    });
  };

  render = () => {
    const {
      metalGroups,
      currentMenuMetalGroup,
      limitedMaterials,
      onCurrentMenuMetalGroupChange,
      assetURI
    } = this.props;

    if (!currentMenuMetalGroup) return null;

    const {
      name,
      material,
      materialOptions,
      surface,
      surfaceOptions,
      purity,
      purityOptions
    } = currentMenuMetalGroup;

    return(
      <div className="threed-configurator-menu-materials-tab">
        {metalGroups.length > 0 &&
          <TabSelect className="threed-configurator-menu-material-group-select"
            tabs={metalGroups.map((metalGroup) => {
              const tab:ITabSelectTab = {
                title: metalGroup.name,
                subTitle: `${metalGroup.material || ''} ${metalGroup.purity ? ` ${metalGroup.purity}` : ''}`,
                isActive: (metalGroup.name === currentMenuMetalGroup.name),
                onClick: () => onCurrentMenuMetalGroupChange(metalGroup.name)
              }
              return tab;
            })}
          />
        }

        <MenuSection className="threed-configurator-menu-section">
          {(materialOptions.length > 0) && <SectionTitle style={{ marginTop: '4px' }}>Choose Material</SectionTitle>}
          <OptionsContainer>
            {(materialOptions.length > 0) && materialOptions.map(option =>
              <Option
                option={option}
                imgName={`${option} ${surface}`}
                assetURI={assetURI}
                isSelected={option === material}
                onClick={(value) => this.onParameterChange(name, 'material', value)}
                key={`${name}---material-${option.toLowerCase().replace(' ', '-')}`}
              >
                {option === material && purityOptions && purityOptions.length > 0 &&
                  <PurityDropdown
                    defaultOption={purity}
                    options={purityOptions}
                    onChange={(value) => this.onParameterChange(name, 'purity', value)}
                  />
                }
              </Option>
            )}
          </OptionsContainer>
        </MenuSection>

        <MenuSection className="threed-configurator-menu-section threed-configurator-menu-section-materials-finish">
          {(surfaceOptions.length > 0 && !limitedMaterials.includes(material)) && 
            <SectionTitle>
              Choose Finish
            </SectionTitle>
          }
          <OptionsContainer>
            {(surfaceOptions.length > 0 && !limitedMaterials.includes(material)) && surfaceOptions.map(option =>
              <Option
                option={option}
                imgName={`${material} ${option}`}
                assetURI={assetURI}
                isSelected={option === surface}
                onClick={(value) => this.onParameterChange(name, 'surface', value)}
                key={`${name}---surface-${option.toLowerCase().replace(' ', '-')}`}
              />
            )}
          </OptionsContainer>
        </MenuSection>

      </div>
    )
  };// /render()
};// /class